var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGraphql(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    className: "opacity-0 my-svg pointer-events-auto animated",
    "data-v-6f4b6142": "",
    style: {
      opacity: 1
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#E434AA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.39 96.852-4.6-2.657L65.04 5.434l4.597 2.656zm0 0",
    style: {
      strokeDashoffset: 0,
      strokeDasharray: "none",
      strokeWidth: 2,
      stroke: "white",
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.734 87.105H115.23v5.31H12.734zm0 0",
    style: {
      strokeDashoffset: 0,
      strokeDasharray: "none",
      strokeWidth: 2,
      stroke: "white",
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.031 119.688 14.766 90.09l2.656-4.602 51.266 29.602zm44.535-77.145L59.301 12.941l2.656-4.597 51.266 29.597zm0 0",
    style: {
      strokeDashoffset: 0,
      strokeDasharray: "none",
      strokeWidth: 2,
      stroke: "white",
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.434 42.523-2.657-4.601 51.27-29.598 2.656 4.598zm0 0",
    style: {
      strokeDashoffset: 0,
      strokeDasharray: "none",
      strokeWidth: 2,
      stroke: "white",
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.621 96.852 58.375 8.09l4.598-2.656 51.25 88.761zM16.8 34.398h5.313v59.204h-5.312zm0 0",
    style: {
      strokeDashoffset: 0,
      strokeDasharray: "none",
      strokeWidth: 2,
      stroke: "white",
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.887 34.398h5.312v59.204h-5.312zm0 0",
    style: {
      strokeDashoffset: 0,
      strokeDasharray: "none",
      strokeWidth: 2,
      stroke: "white",
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.129 117.441-2.32-4.02 44.586-25.745 2.32 4.02zm0 0",
    style: {
      strokeDashoffset: 0,
      strokeDasharray: "none",
      strokeWidth: 2,
      stroke: "white",
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.238 95.328c-3.07 5.344-9.918 7.168-15.261 4.098-5.344-3.074-7.168-9.922-4.098-15.266 3.074-5.344 9.922-7.168 15.266-4.097 5.375 3.105 7.199 9.921 4.093 15.265M29.09 43.84c-3.074 5.344-9.922 7.168-15.266 4.097-5.344-3.074-7.168-9.921-4.097-15.265 3.074-5.344 9.921-7.168 15.265-4.098 5.344 3.106 7.168 9.922 4.098 15.266M9.762 95.328c-3.075-5.344-1.25-12.16 4.093-15.266 5.344-3.07 12.16-1.246 15.266 4.098 3.07 5.344 1.246 12.16-4.098 15.266-5.375 3.07-12.191 1.246-15.261-4.098M98.91 43.84c-3.07-5.344-1.246-12.16 4.098-15.266 5.344-3.07 12.16-1.246 15.265 4.098 3.07 5.344 1.247 12.16-4.097 15.266-5.344 3.07-12.192 1.246-15.266-4.098M64 126.656a11.158 11.158 0 0 1-11.168-11.168A11.158 11.158 0 0 1 64 104.32a11.158 11.158 0 0 1 11.168 11.168c0 6.145-4.992 11.168-11.168 11.168M64 23.68a11.158 11.158 0 0 1-11.168-11.168A11.158 11.158 0 0 1 64 1.344a11.158 11.158 0 0 1 11.168 11.168A11.158 11.158 0 0 1 64 23.68",
    style: {
      strokeDashoffset: 0,
      strokeDasharray: "none",
      strokeWidth: 2,
      stroke: "white",
      fillOpacity: 0
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphql);
export default __webpack_public_path__ + "static/media/graphql.e35664bf141cfa21c4195c40f3b533b7.svg";
export { ForwardRef as ReactComponent };